import { SocketService } from './socketService';
import { EncapMsgDeserializer } from './encapmsg.deserializer';
import { actions } from './actions';
import { ConnectionStatusMessage, WorkerMessage, WorkerMessageType } from './socketMessage';

const socketService = new SocketService();
socketService.setDeserializer(EncapMsgDeserializer);
socketService.streamMessage().subscribe(msg => {
  const message: WorkerMessage = { type: WorkerMessageType.ENCAP, payload: msg };
  self.postMessage(message);
});
socketService.streamConnectionStatus().subscribe(msg => {
  const connectionMsg: ConnectionStatusMessage = { type: msg };
  const message: WorkerMessage = {
    type: WorkerMessageType.CONNECTION_STATUS,
    payload: connectionMsg,
  };
  self.postMessage(message);
});
socketService.streamLatencyLog().subscribe(msg => {
  self.postMessage(
    JSON.stringify({
      type: WorkerMessageType.MESSAGE_LATENCY,
      payload: msg,
    }),
  );
});
socketService.streamLog().subscribe(msg => {
  const message = { type: WorkerMessageType.LOG, payload: msg };
  self.postMessage(message);
});

// eslint-disable-next-line no-restricted-globals
self.addEventListener('message', e => {
  const message = e.data || e;

  switch (message.type) {
    case actions.initSocket.type:
      socketService.connect(message?.payload?.uri, {
        username: message?.payload?.username,
        password: message?.payload?.password,
        clientId: message?.payload?.clientId,
      });
      break;

    case actions.subscribeTopic.type:
      socketService.subscribe(message?.payload?.topics);
      break;

    case actions.unsubscribeTopic.type:
      socketService.unsubscribe(message?.payload?.topics);
      break;

    case actions.disconnect.type:
      socketService.disconnect();
      break;

    case actions.reconnectWithNewUri.type:
      socketService
        .reconnectWithNewUri(
          message?.payload?.uri,
          {
            username: message?.payload?.username,
            password: message?.payload?.password,
            clientId: message?.payload?.clientId,
          },
          message?.payload?.subscribedTopics,
        )
        .then();
      break;

    default:
      break;
  }
});
